import React from "react";
import ProductListCommon from "./ProductListCommon";
import { PAGE_PRODUCT_LIST } from "../../constants/routeConstants";

const ProductList = () => {
    return (
        <ProductListCommon pageName={PAGE_PRODUCT_LIST} parentProductListShow={true} />
    )
}

export default ProductList;